import { fetchPost, fetchGet, fetchPut, fetchDelete } from '../services/Apiservice'

/**
 * Get order list from API
 */
export const orderList = (data) => {
    return fetchGet('/orders', data)
        .then((res) => {
            return res
        })
        .catch((res) => {
            throw res
        })
}

/**
 * Create new customer from API
 */
export const orderCreate = (data) => {

    return fetchPost('/orders', data)
    .then((res) => {
        return res
    })
    .catch((res) => {
        throw res
    })
}

/**
 * Edit order details from API
 */
export const orderEdit = (id, data) => {

    return fetchPut(`/orders/${id}`, data)
        .then(res => res)
        .catch(err => { throw err })
}

/**
 * Get order details from API
 */
export const orderDetail = (id) => {
    return fetchGet(`/orders/${id}`)
        .then(res => res)
        .catch(err => { throw err })
}

/**
 * Delete order data through API
 */
export const orderDelete = (id) => {
    return fetchDelete(`/orders/${id}`)
        .then(res => res)
        .catch(err => { throw err })
}

/**
 * Toggle order status through API
 */
export const orderToggleStatus = (id, data) => {
    return fetchPost(`/orders/${id}/status`, data)
        .then(res => res)
        .catch(err => { throw err })
}


export const orderRedirect = (id, data) => {
    return fetchPost(`/orders/redirect`, data)
        .then(res => res)
        .catch(err => { throw err })
}

export const generateUrl = (data) => {

    return fetchPost('/orders/generate-url', data)
    .then((res) => {
        return res
    })
    .catch((res) => {
        throw res
    })
}
